import { urlDate } from 'helpers/date';
import { useAppSelector } from 'helpers/hooks';
import { useMemo } from 'react';
import { getActiveRole } from 'selectors/admins';
import { getUserClientId } from 'selectors/user';
import {
  getDonationListColumnVisibility,
  getDonationListSearchString,
  getDonationListSortState,
  getUserDates,
} from 'selectors/viewPreferences';
import { useDonorsData } from 'hooks/useDonorsData';
import {
  donationListColumnVisibility,
  donationListSearchString,
  donationListSortState,
} from 'store/viewPreferences/slice';
import DonationDetailContent from 'views/DonationDetail/DonationDetailContent';
import DonorList from 'views/DonationDetail/donorList';
import ReportsDashboard from 'views/DonationDetail/reportsDashboard';
import { partnerDonorColumns } from 'constants/tables';
import { DashboardScreen } from 'helpers/mixpanelEvents';

const sessionStorageKey = 'partnerDonationDetailActiveIndex';
const SCREEN: DashboardScreen = 'partner_donation_detail';

const DonationDetail = () => {
  const activeRole = useAppSelector(getActiveRole);
  const userDates = useAppSelector(getUserDates);
  const userClientId = useAppSelector(getUserClientId);

  const startDate = userDates?.start ? urlDate(userDates.start, 'start') : undefined;
  const endDate = userDates?.end ? urlDate(userDates.end, 'end') : undefined;

  const { donors, isLoading: donorsLoading } = useDonorsData(
    { start_date: startDate ?? '', end_date: endDate ?? '', client_id: userClientId },
    !activeRole || userClientId == null || !startDate || !endDate
  );
  const donorsState = { isLoading: donorsLoading };

  const prefSelectors = useMemo(
    () => ({
      columnVisibility: getDonationListColumnVisibility,
      searchString: getDonationListSearchString,
      sortState: getDonationListSortState,
    }),
    []
  );

  const prefActions = useMemo(
    () => ({
      setColumnVisibility: donationListColumnVisibility,
      setSearchString: donationListSearchString,
      setSortState: donationListSortState,
    }),
    []
  );

  const tabs = useMemo(
    () => [
      {
        label: 'By Donation',
        view: (
          <DonorList
            donors={donors}
            columns={partnerDonorColumns}
            sessionStoragePrefix="donationList"
            screen={SCREEN}
            prefSelectors={prefSelectors}
            prefActions={prefActions}
          />
        ),
      },
      {
        label: 'Reports',
        view: <ReportsDashboard screen={SCREEN} />,
      },
    ],
    [donors, prefSelectors, prefActions]
  );

  return (
    <DonationDetailContent
      activeRole={activeRole}
      donors={donors}
      donorsState={donorsState}
      permissionKey="DONATION_LIST_ROUTE"
      screen={SCREEN}
      sessionStorageKey={sessionStorageKey}
      tabs={tabs}
      userClientId={userClientId}
      userDates={userDates}
    />
  );
};

export default DonationDetail;
